/**
 * Forgot password — /forgot-password
 */
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import BrandMark from "@/components/BrandMark";
import AuthLegalFooter from "@/components/legal/AuthLegalFooter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/password-reset/request`, { email });
      setSent(true);
      toast.success("If that email exists, a reset link is on its way.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Request failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col" data-testid="forgot-password-page">
      <div className="flex-1 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-card border border-border rounded-2xl p-8">
        <BrandMark size={48} className="rounded-lg mb-4" />
        <h1 className="font-display text-2xl font-bold mb-1">Forgot your password?</h1>
        <p className="text-sm text-muted-foreground mb-6">We'll send you a reset link if we recognize your email.</p>
        {sent ? (
          <div className="space-y-3">
            <div className="rounded-md bg-emerald-500/10 border border-emerald-500/30 p-3 text-sm text-emerald-500" data-testid="reset-sent">
              Check your inbox. If we have an account for <b>{email}</b>, a reset link is on its way.
            </div>
            <Link to="/login" className="text-sm text-primary underline">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input type="email" placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-background border border-border rounded-md px-4 py-3 text-sm outline-none focus:border-primary" data-testid="forgot-email" required />
            <button type="submit" disabled={busy} className="w-full bg-primary text-primary-foreground py-3 rounded-md font-semibold text-sm disabled:opacity-50" data-testid="forgot-submit">
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <div className="text-center text-xs text-muted-foreground pt-2">
              Remembered it? <Link to="/login" className="text-primary underline">Log in</Link>
            </div>
          </form>
        )}
      </div>
      </div>
      <AuthLegalFooter />
    </div>
  );
}
